// client/src/api/dripApi.js
//
// Drip M3.3 - Cliente API del editor de la secuencia de nurture.
//   GET   /admin/drip/sequence
//   PATCH /admin/drip/sequence
// Mismo patron que leadsApi (fetch nativo + Bearer + ENV.BASE_API).

import { ENV } from "../Utils";

async function doFetch(url, params = {}) {
  const res = await fetch(url, params);
  const ct = res.headers.get("content-type") || "";
  const parse = ct.includes("application/json")
    ? () => res.json()
    : () => res.text();
  const data = await parse().catch(() => ({}));
  if (!res.ok) {
    const err = new Error(data?.message || `Request error ${res.status}`);
    err.status = res.status;
    err.body = data;
    throw err;
  }
  return data;
}

const authHeaders = (token) =>
  token ? { Authorization: `Bearer ${token}` } : {};

export class DripApi {
  /** @returns {Promise<{data:{sequence, envGate, offerCode}}>} */
  getSequence(accessToken) {
    return doFetch(`${ENV.BASE_API}/admin/drip/sequence`, {
      method: "GET",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  /**
   * Funnel de activacion post-compra (solo lectura): pasos en codigo.
   * @returns {Promise<{data:{sequence, audience, day0, steps}}>}
   */
  getPaidSequence(accessToken) {
    return doFetch(`${ENV.BASE_API}/admin/drip/paid-sequence`, {
      method: "GET",
      headers: { Accept: "application/json", ...authHeaders(accessToken) },
    });
  }

  /**
   * @param {object} patch - { active?, offer_pct?, steps?:[{step,dayOffset,subject,active}] }
   */
  patchSequence(accessToken, patch) {
    return doFetch(`${ENV.BASE_API}/admin/drip/sequence`, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
        ...authHeaders(accessToken),
      },
      body: JSON.stringify(patch),
    });
  }
}

export const dripApi = new DripApi();
